package kz.dentalcrm.app.core.ui.components.lazy_column

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.reload
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.filter
import kz.dentalcrm.app.core.ui.components.InfiniteProgress
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource

@Composable
fun PaginatedLazyColumn(
    modifier: Modifier,
    loadMoreItems: () -> Unit,
    listState: LazyListState,
    buffer: Int = 10,
    isLoading: Boolean,
    paginatedTextError: String? = null,
    retryOnPaginated: () -> Unit = { },
    paginatedError: LazyListScope.() -> Unit = {
        item {
            if (paginatedTextError.isNullOrEmpty().not()) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    Text(
                        modifier = Modifier.fillMaxWidth(),
                        textAlign = TextAlign.Center,
                        text = paginatedTextError.orEmpty(),
                        style = DefaultTheme.typography.captionRegular,
                        color = DefaultTheme.colors.onSurface
                    )
                    Spacer(modifier = Modifier.height(12.dp))
                    UIButton(
                        modifier = Modifier
                            .widthIn(min = 160.dp)
                            .height(32.dp),
                        contentPadding = PaddingValues(horizontal = 16.dp),
                        text = stringResource(Res.string.reload),
                        style = DefaultTheme.typography.captionMedium,
                        onClick = retryOnPaginated
                    )
                    Spacer(modifier = Modifier.height(12.dp))
                }
            }
        }
    },
    paginatedLoading: LazyListScope.() -> Unit = { },
    itemsContent: LazyListScope.() -> Unit,
) {

    val currentLoadingState by rememberUpdatedState(newValue = isLoading)

    val shouldLoadMore by remember {
        derivedStateOf {
            // Get the total number of items in the list
            val totalItemsCount = listState.layoutInfo.totalItemsCount
            // Get the index of the last visible item
            val lastVisibleItemIndex =
                listState.layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: 0
            // Check if we have scrolled near the end of the list and more items should be loaded
            lastVisibleItemIndex >= (totalItemsCount - buffer) &&
                    currentLoadingState.not() &&
                    (totalItemsCount - buffer) > 0
        }
    }


    LaunchedEffect(listState) {
        snapshotFlow { shouldLoadMore }
            .distinctUntilChanged()
            .filter { it }
            .collect {
                loadMoreItems()
            }
    }

    LazyColumn(
        modifier = modifier,
        state = listState
    ) {

        itemsContent()
        paginatedLoading()
        paginatedError()
    }
}